import styled, { css } from 'styled-components'
// themes
import { colors } from 'themes/index'
// views
import {
  TableContent,
  TableContainer,
  DraggableContainer,
  DroppableContainer
} from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table/views'
import { RowsWrapper } from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table/components/TableForm/components/Rows/views'
import { OuterWrapper } from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table/components/TableForm/components/Rows/components/Row/views'
import { TableFieldWrapper } from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table/components/TableField/views'
import { RiskContainerWrapper } from 'components/PageComponents/Risks/Register/components/RiskView/components/RisksContainer/components/RiskContainer'

export const RisksContainerWrapper = styled.div`
  background-color: ${colors.gray190};
  border-radius: 4px;
  overflow: auto;
  padding: 0 12px;
  flex: 1;

  ${TableContent} {
    max-height: unset;
    overflow: unset;
    gap: 12px;

    > div:first-child {
      height: 100%;
    }
  }

  ${DroppableContainer} {
    gap: 12px;
  }

  ${TableFieldWrapper} {
    margin: 0;
  }

  ${RowsWrapper} {
    padding-right: 0;

    > div {
      padding-right: 0;
    }
  }

  ${OuterWrapper} {
    padding: 0 !important;
    background-color: unset;
  }
`

const oddStyles = css`
  ${RiskContainerWrapper} {
    background: ${colors.gray270};
  }

  ${TableContainer} {
    background-color: ${colors.gray270};
  }

  ${TableContent} {
    background-color: ${colors.gray270};
  }

  ${DraggableContainer} {
    background-color: ${colors.gray270};
  }

  ${TableFieldWrapper} {
    height: 100%;
    background-color: ${colors.gray270};
  }

  .form {
    background-color: ${colors.gray270};
  }
`

export const Container = styled.div<{ $isInfinityList?: boolean }>`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  & *::before {
    visibility: hidden !important;
  }

  & .form {
    height: 100%;
    padding-right: 12px;
    border-right: 1px solid darkgray;
    min-height: 32px;

    *::before {
      visibility: inherit !important;
    }
  }

  ${DraggableContainer} {
    > div {
      height: 100%;
    }
  }

  ${TableFieldWrapper} {
    border-right: 1px solid darkgray;
  }

  ${TableContainer} {
    min-height: 32px;
  }

  ${({ $isInfinityList }) =>
    $isInfinityList
      ? css`
          > div > div:nth-child(2) > div > div:nth-child(odd) {
            ${oddStyles}
          }
        `
      : css`
          > div:nth-child(odd) {
            min-height: 48px;
            background-color: ${colors.gray270};
            ${oddStyles}
          }
        `}
`
